import { render } from "./ManageProjectListPage.vue?vue&type=template&id=23f8c302&scoped=true"
import script from "./ManageProjectListPage.vue?vue&type=script&lang=ts"
export * from "./ManageProjectListPage.vue?vue&type=script&lang=ts"

import "./ManageProjectListPage.vue?vue&type=style&index=0&id=23f8c302&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23f8c302"

export default script